import { Input, Popover, Space, Tooltip } from 'antd'
import { StarOutlined, StarFilled } from '@ant-design/icons'
import { useTranslation } from 'react-i18next'
import Typography from '../../Typography/Typography'
import ButtonActionBar from '../../ButtonActionBar/ButtonActionBar'
import Button from '../../Button/Button'

const FavouriteIcon = ({
  visible,
  favouriteName,
  setFavouriteName,
  onClickCancelSaveFav,
  onClickSave,
  loading,
  alreadyExist,
  onClickSaveFav,
  options,
}) => {
  const { t } = useTranslation()
  return (
    <Popover
      trigger="click"
      visible={visible}
      content={
        <Space direction="vertical">
          <Typography.Body level={3}>{t('TYPOGRAPHY_ENTER_VIEW_NAME')}</Typography.Body>
          <Input
            placeholder={t('ENTER_NAME_PLACEHOLDER')}
            value={favouriteName}
            onChange={(val) => setFavouriteName(val.target.value)}
          />
          <ButtonActionBar>
            <Button.Default title="ACTION_CANCEL" onClick={onClickCancelSaveFav} />
            <Button.Primary
              title="ACTION_SAVE"
              onClick={onClickSave}
              loading={loading}
              disabled={options.find((el) => el.name === favouriteName)}
              tooltipTitle={
                options.find((el) => el.name === favouriteName)
                  ? t('ALREADY_EXISTS_NAME_TOOLTIP_TITLE')
                  : ''
              }
            />
          </ButtonActionBar>
        </Space>
      }
    >
      <Tooltip title={t('FAVOURITE_ICON_INFORMATIVE_TOOLTIP_TITLE')}>
        <Button.Icon
          title={alreadyExist ? t('FIELD_FAVORITE') : t('ACTION_ADD_FAVORITE')}
          icon={<Typography.Icon icon={alreadyExist ? StarFilled : StarOutlined} />}
          onClick={!alreadyExist && onClickSaveFav}
          style={alreadyExist ? { cursor: 'default' } : {}}
        />
      </Tooltip>
    </Popover>
  )
}

export default FavouriteIcon
